import { render, staticRenderFns } from "./visitlog.vue?vue&type=template&id=2c0dcea7&scoped=true"
import script from "./visitlog.vue?vue&type=script&lang=js"
export * from "./visitlog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0dcea7",
  null
  
)

export default component.exports